
import "./ContentBar.css";
import Header from "../Header/Header";
import Container from "../Container/Container";
import { useSelector } from "react-redux";

const ContentBar = () => {
  const step = useSelector((state) => state.step);
  return (
    <div className="ContentBar">
      {step !== 5 && <Header />}

      <Container />
    </div>
  );
};

export default ContentBar;
